<template>
  <UTabs
    v-model="modelValue"
    class="detail-tabs"
    :color="color"
    :variant="variant"
    :content="content"
    :items="items"
    :class="tabsClass"
    :ui="{
      list: 'scrollbar-none',
      trigger: 'pr-4.25 pl-4',
    }"
  />
</template>

<script lang="ts" setup>
import type { TabsItem, TabsProps } from '@nuxt/ui'

defineOptions({
  name: 'DetailTabs',
})

defineProps<{
  color?: TabsProps['color']
  variant?: TabsProps['variant']
  content?: TabsProps['content']
  items: TabsItem[]
  tabsClass?: TabsProps['class']
}>()

const modelValue = defineModel<TabsProps['modelValue']>('modelValue')

const scrollToActiveTab = () => {
  if (import.meta.client && window.innerWidth < 1280) {
    const activeTab = document.querySelector(
      '[data-slot="trigger"][aria-selected="true"]',
    )
    if (activeTab) {
      activeTab.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      })
    }
  }
}

onMounted(() => {
  scrollToActiveTab()
})
</script>

<style lang="scss" scoped>
.detail-tabs {
  --ui-text-muted: var(--color-neutral-default);
  // p-1 border border-neutral-border-default rounded-[8px] bg-transparent
  padding: 4px;
  background-color: transparent;
  max-width: 100%;
  overflow-x: auto;

  :deep([data-slot='list']) {
    background-color: transparent;
    border: 1px solid var(--color-neutral-border-default);
    max-width: 100%;
    overflow-x: auto;
  }

  :deep([data-slot='trigger']) {
    flex-shrink: 0;
    min-width: max-content;
    position: relative;

    &:not([aria-selected='true']):not(:first-of-type):before {
      content: '';
      position: absolute;
      left: 0;
      width: 1px;
      height: 16px;
      background-color: var(--color-border-light);
    }

    &[aria-selected='true'] + button:before {
      opacity: 0;
    }
  }
}
</style>
